import { Link , useLocation} from 'react-router-dom';
import DropdownUser from './DropdownUser';
import { RxHamburgerMenu } from 'react-icons/rx';
import {get} from "../../helpers/api_helper"
import { useEffect, useState } from 'react';


const Header = (props) => {
  const [userInfo, setUserInfo] = useState({ claimBalance: 0, sharedProducts: [] });
  const location = useLocation();
  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const response = await get('/userInfo'); 
        const { claimBalance, sharedProducts, verifiedBalance } = response;
        setUserInfo({ claimBalance, sharedProducts,verifiedBalance });
      } catch (error) {
        console.error('Error fetching user info:', error);
      }
    };

    fetchUserInfo();
  }, [location.pathname]); 
  return (
    <header className="sticky top-0 flex w-full shadow-md z-50 bg-[#D4C1A7]">
      <div className="flex flex-grow items-center justify-between py-4 px-4 shadow-2 md:px-6 2xl:px-11">
        <div className="flex items-center gap-2 sm:gap-4 lg:hidden">
          <button
            aria-controls="sidebar"
            onClick={(e) => {
              e.stopPropagation();
              props.setSidebarOpen(!props.sidebarOpen);
            }}
            className="z-99999 block rounded-sm border border-stroke bg-white p-1.5 shadow-sm dark:border-strokedark dark:bg-boxdark lg:hidden"
          >
            <RxHamburgerMenu
              size={24}
              className={`${
                !props.sidebarOpen ? '' : ''
              } text-black dark:text-white`}
            />
          </button>
          <Link className="block flex-shrink-0 lg:hidden w-16 mr-2 " to="/userDash">
            <img src={require("../../asset/img/favicon.jpg")} alt="Logo" className='h-7 '/>
          </Link>
        </div>

       
        <div className="sm:block max-[768px]:text-xs">
          <div className="flex items-center gap-6">
            <div className="text-gray-700 dark:text-gray-300">
              Claim Balance:
              <span className="font-semibold text-gray-900 dark:text-white"> {userInfo.claimBalance}/-</span>
            </div>
            <div className="text-gray-700 dark:text-gray-300">
              Verified Balance:
              <span className="font-semibold text-gray-900 dark:text-white"> {userInfo.verifiedBalance}/-</span>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-3 2xsm:gap-7">
          <ul className="flex items-center gap-2 2xsm:gap-4">
            
          
          </ul>
          <DropdownUser />
        </div>
      </div>
    </header>
  );
};

export default Header;
